import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import { menuCreator } from '../module/menuCreator';
export const store = new Vuex.Store({
    state: {
        //==============================================  
        groups: [],
        topGroups: [],
        navbarmenu: [],
        sliders: [],
        blogs: [],
        amazingOffers: [],
        promoSectionProducts: [],
        brands: [],
        usefulLinks: [],
        suggestedProducts: [],
        homePageContents: null,
        banners: [],
        productReviews: [],
        newestProduct: [],
        productCategories: [],
        baseInfo: null,
        //==============================================  
        userFullName: '',
        mobNo: '',
        //==============================================
        confirm: {
            confirmationCodeHashId: '',
            timeRemaningForExpire: 0
        },
        //==============================================
        cart: null,
    },

    getters: {
        //============================================== 
        readTopGroups: state => {
            return state.topGroups;
        },
        //============================================== 
        readGroups: state => {
            return state.groups;
        },
        readNavbarmenu: state => {
            return state.navbarmenu;
        },
        readSliders: state => {
            return state.sliders;
        },
        readAmazingOffers: state => {
            return state.amazingOffers;
        },
        readPromoSectionProducts: state => {
            return state.promoSectionProducts;
        },
        readHomePageContents: state => {
            return state.homePageContents;
        },
        readBrands: state => {
            return state.brands;
        },
        readUsefulLinks: state => {
            return state.usefulLinks;
        },
        readSuggestedProducts: state => {
            return state.suggestedProducts;
        },
        readBaseInfo: state => {
            return state.baseInfo;
        },
        readBlogs: state => {
            return state.blogs;
        },
        readProductReviews: state => {
            return state.productReviews;
        },
        readNewestProduct: state => {
            return state.newestProduct;
        },
        readproductCategories: state => {
            return state.productCategories;
        },
        //============================================== 
        readUserFullName: state => {
            return state.userFullName;
        },
        readUserMobNo: state => {
            return state.mobNo;
        },
        readDurationMembership: state => {
            return state.durationMembership;
        },
        readOrderSuccessCount: state => {
            return state.orderSuccessCount;
        },
        //==============================================
        readConfirm: state => {
            return state.confirm;
        },
        //===============================================
        readCart: state => {
            return state.cart
        },
        readBanners: state => {
            return state.banners
        }
    },
    mutations: {
        //============================================== 
        setHomePageContents: (state, data) => {
            state.homePageContents = data;
            state.groups = data.Groups;
            state.topGroups = data.TopGroups;
            state.navbarmenu = menuCreator(state.groups);
            state.sliders = data.Sliders;
            state.amazingOffers = data.AmazingOffers;
            state.promoSectionProducts = data.PromoSectionProducts;
            state.brands = data.Brands;
            state.usefulLinks = data.UsefulLinks;
            state.suggestedProducts = data.SuggestedProducts;
            state.userFullName = data.CustomerFullName;
            state.mobNo = data.MobileNo;
            state.durationMembership = data.DurationMembership;
            state.orderSuccessCount = data.OrderSuccessCount;
            state.banners = data.Banners,
            state.baseInfo = data.BaseInfos;
            state.blogs = data.Blogs;
            state.productCategories = data.ProductCategories;
            state.productReviews = data.ProductReviews;
            state.newestProduct = data.NewestProduct;
            if (data.IsUserLogined == false)
                localStorage.removeItem('accessToken');
        },
        //============================================== 
        setUserFullName: (state, data) => {
            state.userFullName = data;
        },
        //==============================================
        setConfirm: (state, data) => {
            state.confirm.confirmationCodeHashId = data.ConfirmationCodeHashId;
            state.confirm.timeRemaningForExpire = data.TimeRemaningForExpire;
        },
        //==============================================
        setCart: (state, data) => {
            state.cart = data;
        }
        //==============================================
    }
});